import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProjectCategoryUIHelpers";

const ProjectCategoryUIContext = createContext();

export function useProjectCategoryUIContext() {
  return useContext(ProjectCategoryUIContext);
}

export function ProjectCategoryUIProvider({ 
  projectCategoryUIEvents, 
  children, 
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initProjectCategory = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initProjectCategory,
    newProjectCategoryButtonClick: projectCategoryUIEvents.newProjectCategoryButtonClick,
    openEditProjectCategoryPage: projectCategoryUIEvents.openEditProjectCategoryPage,
    openDeleteProjectCategoryPage: projectCategoryUIEvents.openDeleteProjectCategoryPage,
  };

  return (
    <ProjectCategoryUIContext.Provider value={value}>
      {children}
    </ProjectCategoryUIContext.Provider>
  );
}
